import { c as _c } from "react/compiler-runtime";
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { FormGroup } from '@mui/material';
import { useFiltersAnalytics } from 'src/features/roundup-filters/store/hooks/useFiltersAnalytics';
import { useShallow } from 'zustand/shallow';
import { useOffersFilterStore } from '../../../store/Context';
import { FilterType } from '../../../store/enums';
import type { OffersFilterStoreState } from '../../../store/types';
import type { FilterOption } from '../../../types';
import { Accordion } from '../InputAccordion/Accordion';
import { FormLabeledListItem } from '../InputAccordion/FormLabeledListItem';
import { CheckboxWithCount } from '../InputAccordion/MultiSelect/CheckboxWithCount';
type Props = {
  options: FilterOption[];
};
export function Issuers(t0) {
  const $ = _c(4);
  const {
    options
  } = t0;
  let t1;
  if ($[0] !== options) {
    t1 = options.map(_temp);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Accordion title="Issuers"><FormGroup>{t1}</FormGroup></Accordion>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(option) {
  return <FormLabeledListItem key={option.value} control={<Checkbox value={option.value} />} label={option.label} />;
}
function Checkbox(t0) {
  const $ = _c(9);
  const {
    value
  } = t0;
  const {
    issuerFilter,
    handleApplyFilters,
    handleSingleFormUpdate
  } = useOffersFilterStore(useShallow(_temp2));
  const {
    fireIssuerUpdateEvents
  } = useFiltersAnalytics();
  let t1;
  if ($[0] !== fireIssuerUpdateEvents || $[1] !== handleApplyFilters || $[2] !== handleSingleFormUpdate || $[3] !== issuerFilter) {
    t1 = newSelected => {
      handleSingleFormUpdate({
        value: newSelected,
        type: FilterType.ISSUER
      });
      requestIdleCallback(() => {
        handleApplyFilters();
        fireIssuerUpdateEvents({
          prevSelectedValues: issuerFilter,
          newSelectedValues: newSelected
        });
      });
    };
    $[0] = fireIssuerUpdateEvents;
    $[1] = handleApplyFilters;
    $[2] = handleSingleFormUpdate;
    $[3] = issuerFilter;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleChange = t1;
  let t2;
  if ($[5] !== handleChange || $[6] !== issuerFilter || $[7] !== value) {
    t2 = <CheckboxWithCount id="issuers" selectedValues={issuerFilter} value={value} updateValue={handleChange} />;
    $[5] = handleChange;
    $[6] = issuerFilter;
    $[7] = value;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}
function _temp2(state) {
  return {
    issuerFilter: state.filterFormState.issuerFilter,
    handleApplyFilters: state.handleApplyFilters,
    handleSingleFormUpdate: state.handleSingleFormUpdate
  };
}